import React from 'react';
import { Box, Button, HStack } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';

import { nextKey } from '../../utils';
import { EESchool } from './eeSchool';

export const EEducation = ({ state, setter, onBlur }) => {
	const remove = e => {
		const { name } = e.target;
		const newState = { ...state };
		delete newState[name];
		setter(newState);
	};

	const add = () => {
		const next = nextKey(state);
		setter({ ...state, [next]: {} });
	};

	return (
		<Box>
			{Object.keys(state).map(key => {
				const id = key;
				const item = state[key];
				const setItem = item => setter({ ...state, [key]: item });
				const school = { id, remove, state: item, setter: setItem, onBlur };

				return <EESchool key={key} {...school} />;
			})}
			<HStack pt={4}>
				<Button
					leftIcon={<AddIcon />}
					colorScheme="blue"
					variant="solid"
					onClick={add}
				>
					Добавить место учёбы
				</Button>
			</HStack>
		</Box>
	);
};
